import React, { useState, useEffect } from 'react';
import Navbar from '../components/NavBar';
import Sidebar from '../components/SideBar';
import Header from '../components/Header';
import AboutSection from '../components/AboutSection';
import ProductSection from '../components/ProductSection';
import BrandsSection from '../components/BrandsSection';
import ServicesSection from '../components/ServicesSection';
import TeamSection from '../components/TeamSection';
import MapSection from '../components/MapSection';
import CTASection from '../components/CallToAction';
import TestinomialsSection from '../components/TestinomialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import TopHeader from '../components/TopHeader';
import ScrollToTop from '../components/ScrollToTop';
import { Helmet } from "react-helmet-async";


import '../styles/bootstrap.min.css';  
import '../styles/lineicons.css';          
import '../styles/tiny-slider.css';        
import '../styles/glightbox.min.css';      
import '../styles/style.css';             

const HomePage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  
  useEffect(() => {
    // Load external scripts
    const loadScripts = () => {
    };

    loadScripts();

    
    const handleAnchorClick = (e) => {
      const href = e.currentTarget.getAttribute('href');
    if (href && href.startsWith('#') && href.length > 1) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: 'smooth'
        });
      }
    }
   
    else if (href === '#') {
      e.preventDefault();
      
    }

    };

   
    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach(anchor => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    return () => {
      anchors.forEach(anchor => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, []);


  const handleSidebarToggle = () => {
    console.log('Toggling sidebar, current state:', isSidebarOpen);
    setIsSidebarOpen(!isSidebarOpen);
  };

 
  const handleSidebarClose = () => {
    console.log('Closing sidebar');
    setIsSidebarOpen(false);
  };

 
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && isSidebarOpen) {
        handleSidebarClose();
      }
    };

    window.addEventListener('keydown', handleEscKey);
    return () => window.removeEventListener('keydown', handleEscKey);
  }, [isSidebarOpen]);


  return (
    <div className="home-page">
      <Helmet>
      <title>Z1 Technology & Trade | Home</title>
      <meta
        name="description"
        content="Leading IT Company in Nepal for Software, ERP, GPS & Digital Solutions"
      />

      {/* Open Graph */}
      <meta property="og:title" content="Z1 Technology & Trade | Home" />
      <meta
        property="og:description"
        content="Z1 Technology & Trade Pvt. Ltd. is a trusted IT company in Nepal providing ERP software, GPS tracking systems, CCTV solutions, digital signage, and custom software development for government and businesses since 2002."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://yourcompany.com/" />
      <meta property="og:image" content="https://yourcompany.com/og-home.jpg" />

      {/* Canonical */}
      <link rel="canonical" href="https://yourcompanyofficialurl.com/" />
    </Helmet>

      <TopHeader />
      <Navbar onSidebarToggle={handleSidebarToggle} />
      <Sidebar isOpen={isSidebarOpen} onClose={handleSidebarClose} />
      <Header />
      <AboutSection />
      <ProductSection/>
      <BrandsSection/>
      <ServicesSection />
      <CTASection />
      <TeamSection />
      {/* <BlogSection /> */}
      {/* <ClientsSection /> */}
      <TestinomialsSection />
      <ContactSection />
      <MapSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default HomePage;